// lib/logicalCanvas/storage.js
/**
 * Logical Canvas Local Storage Helper
 * 
 * Manages persistence of user's plugin selections in localStorage
 */

const STORAGE_KEY = "lc.plugins.selection.v0";

/**
 * Load user's local plugin selection from localStorage
 * @returns {object} localSelection - Map of capabilityId -> { enabled, mode }
 */
export function loadSelection() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return {};
    
    const parsed = JSON.parse(stored);
    return parsed || {};
  } catch (err) {
    console.error("Failed to load plugin selection from localStorage:", err);
    return {};
  }
}

/**
 * Save user's local plugin selection to localStorage
 * @param {object} selection - Map of capabilityId -> { enabled, mode }
 */
export function saveSelection(selection) {
  try {
    const serialized = JSON.stringify(selection);
    localStorage.setItem(STORAGE_KEY, serialized);
  } catch (err) {
    console.error("Failed to save plugin selection to localStorage:", err);
  }
}

/**
 * Clear all local plugin selections
 */
export function clearSelection() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (err) {
    console.error("Failed to clear plugin selection:", err);
  }
}

/**
 * Update a single capability in the selection
 * @param {string} capabilityId 
 * @param {boolean} enabled 
 * @param {string} mode 
 */
export function updateCapability(capabilityId, enabled, mode) {
  const current = loadSelection();
  current[capabilityId] = { enabled, mode };
  saveSelection(current);
}

/**
 * Check if there are any local selections
 * @returns {boolean}
 */
export function hasLocalSelections() {
  const selection = loadSelection();
  return Object.keys(selection).length > 0;
}
